export enum UserRoles {
  CAPTAIN = 'captain',
  CHARITY = 'charity',
  CHARITY_DRIVER = 'charity_driver',
  DRIVER = 'driver',
  PARTNER = 'partner',
  STORE = 'store',
}
